import React from 'react';
import { ButtonUI, CardModuleUI } from '../../common';
import {
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  withStyles,
} from '@material-ui/core';
import { MessageText } from './MessageText';

const CardStore_ = ({
  title,
  classes,
  setAlert,
  idCountry,
  domainStore,
  handleOmitirClick,
}) => {
  const handleCopyLink = () => {
    let copyText = document.getElementById('link_tienda');
    copyText.select();
    copyText.setSelectionRange(0, 99999);
    document.execCommand('copy');

    setAlert({
      open: true,
      type: 'success',
      message: 'El link de tu tienda ha sido copiado',
    });
  };

  const domainResources = 'https://recursos.empretienda.com';
  const linkButtonTips = `${domainResources}/5-tips-para-la-tienda${
    idCountry === 'COL' ? '-col' : ''
  }.pdf`;

  return (
    <CardModuleUI>
      <Grid container className={classes.container}>
        <Grid item xs={12}>
          <div className={classes.containerTitle}>
            <h3 className={classes.title}>{title}</h3>
          </div>
        </Grid>
        <Grid item xs={12}>
          <Grid item xs={12}>
            <MessageText idCountry={idCountry} />
            <TextField
              multiline
              fullWidth
              margin="normal"
              id="link_tienda"
              variant="outlined"
              value={domainStore}
              InputProps={{
                endAdornment: (
                  <Tooltip title="Copiar link" placement="left">
                    <InputAdornment position="end">
                      <IconButton onClick={handleCopyLink}>
                        <Icon>filter_none</Icon>
                      </IconButton>
                    </InputAdornment>
                  </Tooltip>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} className={classes.containerButtons}>
            <ButtonUI
              type="callf"
              variant="text"
              label="Omitir"
              fullWidth={false}
              onClickFunc={handleOmitirClick}
              classes={{ root: classes.closeButton }}
            />
            <ButtonUI
              type="link"
              open_new_tab
              external_link
              fullWidth={false}
              variant="contained"
              link={linkButtonTips}
              label="Tips para vender más"
              classes={{ root: classes.button }}
            />
          </Grid>
        </Grid>
      </Grid>
    </CardModuleUI>
  );
};

const styles = (theme) => ({
  container: {
    padding: '0',
    [theme.breakpoints.up('sm')]: {
      padding: '0 24px',
    },
  },
  containerTitle: {
    marginBottom: '18px',
    [theme.breakpoints.up('sm')]: {
      marginBottom: '43px',
    },
  },
  title: {
    fontWeight: '600',
    fontSize: '1.5rem',
    lineHeight: '28px',
    color: '#53B755',
    margin: '0px',
  },
  containerButtons: {
    wrap: 'nowrap',
    display: 'flex',
    marginTop: '24px',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  closeButton: {
    textTransform: 'none',
    color: '#383838',
    marginRight: '24px',
  },
  button: {
    textTransform: 'none',
  },
});

export const CardStore = withStyles(styles)(CardStore_);
